export default {
	websiteErr: '网站显示异常，请确认后重试！',
	searchBtn: '搜索',
	searchPlaceholder: '请输入商品关键字',
	platform: '代购平台',
	selectPlatform: '请选择代购平台',
	buyNow: '立即购买',
	bestSeller: '热卖',
	newArrivals: '上新',
	all: '全部',
	viewAll: '查看全部',
	noData: '暂无数据',
	noProduct: '暂无商品',
	dataLoading: '数据加载中...',
	loadingFinish: '已加载全部数据',
	selectCategory: '选择分类',
	selectBrand: '选择品牌',
	selectPlatform2: '选择代购平台',
	close: '关闭'
}